module.exports = __webpack_public_path__ + "assets/security-black.e27889e6.svg";